import { Divider, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
    Control,
    FieldErrors,
    UseFormRegister,
    UseFormReset,
    UseFormSetValue,
} from "react-hook-form";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import WSHiddenField from "../../Components/HiddenField/WSHiddenField";
import WSButton from "../../Components/Button/WSButton";
import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "../../StateManagement/types";
import { callAPI, Method } from "../../commonFunctions/CommonFunctions";

interface NotesProps {
    control?: Control<any>;
    errors?: FieldErrors;
    register: UseFormRegister<any>;
    id: any;
    reset: UseFormReset<any>;
    noteId?: string;
    setValue: UseFormSetValue<any>;
    onCancel: () => void
}

const DrawyerNote: React.FC<NotesProps> = ({
    control, id, register, noteId, reset, setValue, onCancel
}) => {
    useEffect(() => {
        return () => {
            reset();
        };
    }, []);
      useEffect(() => {
            const getNotes = async () => {
                try {
                    const response: any = await callAPI(`notes`, Method.GET, null, noteId);
                    if (response && response.data) {
                        setValue('content', response?.data.content)
                        setValue('leadId', response?.data.leadId)
                    }
                }
                catch (e) {
                }
            }
            if (noteId) {
                getNotes();
            }
        }, [noteId])
    const reduxComponentData = useSelector(
        (state: AppState) => state.components["noteSubmit"],
        shallowEqual
    );

    // Local state to store Redux data
    const [componentData, setComponentData] = useState(reduxComponentData);

    // Update useState when Redux state changes
    useEffect(() => {
        if (reduxComponentData) {
            setComponentData(reduxComponentData);
        }
    }, [reduxComponentData]);

    return (
        <Grid >
            {<Grid container spacing={2} mt={2}>
                <Grid item xs={12}>
                    <WSTextAreaField
                        size="small"
                        label="Add Note"
                        id="content"
                        setValue={setValue}
                        control={control}
                        {...register("content")}
                        rules={{ required: true }}
                        name="content"
                        rows={4}
                    />
                    <WSHiddenField control={control} name="noteId" defaultValue={noteId} />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <Divider />
                </Grid>
                <Grid item container spacing={2} style={{ paddingTop: '1rem' }} justifyContent={'end'}>
                    <Grid item sx={{ marginRight: 0 }}>
                        <WSButton className="ws-theme-crm" loading={reduxComponentData?.data?.loading} variant="outlined" id='noteSubmit' label={"Save"} type="submit" size="medium" />
                    </Grid>
                    <Grid item sx={{ marginRight: 0 }}>
                        <WSButton id='cancel' label={"Cancel"} onClick={onCancel} type="button" size="medium" variant="outlined" className="ws-theme-crm" />
                    </Grid>
                </Grid>
            </Grid>

            }
        </Grid>
    );
};
export default DrawyerNote;
